import {DatabaseCode, toDatabaseCode} from "./database-code";
import {notificationChannel, NotificationChannel} from "./notification-channel";

export type NotificationProviderType = DatabaseCode & {
  channel: NotificationChannel
}

const smtp: NotificationProviderType = {
  code: 'SMTP',
  displayValue: {
    id: 'common.entity.notification.provider.smtp',
    defaultMessage: 'SMTP',
  },
  channel: notificationChannel.email,
};

const office365: NotificationProviderType = {
  code: 'OFFICE365',
  displayValue: {
    id: 'common.entity.notification.provider.office365',
    defaultMessage: 'Office 365 (Outlook)',
  },
  channel: notificationChannel.email,
};

const ses: NotificationProviderType = {
  code: 'SES',
  displayValue: {
    id: 'common.entity.notification.provider.ses',
    defaultMessage: 'Amazon SES',
  },
  channel: notificationChannel.email,
};

const twilio: NotificationProviderType = {
  code: 'TWILIO',
  displayValue: {
    id: 'common.entity.notification.provider.twilio',
    defaultMessage: 'Twilio SMS',
  },
  channel: notificationChannel.sms,
};

export const notificationProviderType = {
  smtp,
  office365,
  ses,
  twilio,
};

export const notificationProviderTypes = Object.values(notificationProviderType);

export const toNotificationProviderType = (code: string): NotificationProviderType => toDatabaseCode(code, notificationProviderTypes);
export const toNotificationProviderTypeSafely = (code: string | undefined): NotificationProviderType | undefined => code ? toDatabaseCode(code, notificationProviderTypes) : undefined;
